import { CREATE_XMLGENERATOR } from '../types'

const INITIAL_STATE = {
  getXMLGenerator: [],
}

const xmlReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case CREATE_XMLGENERATOR:
      return {
        ...state,
        getXMLGenerator: payload.data,
      }
    default:
      return state
  }
}

export default xmlReducer
